import { TtDateRangePipe } from '../pipes/tt-date-range/tt-date-range.pipe';
import { TtNumberRangePipe } from '../pipes/tt-number-range/tt-number-range.pipe';

export function tsRangeHumanReadableString(
  range: Parameters<TtDateRangePipe['transform']>[0],
  divider: string = ' - ',
  formatString: string = 'EEE d-LLL HH:mm',
): string {
  return new TtDateRangePipe().transform(range, {
    divider: divider,
    format: formatString,
  });
}

export function dateRangeHumanReadableString(
  range: Parameters<TtDateRangePipe['transform']>[0],
  divider: string = ' - ',
  formatString: string = 'EEE d-LLL',
) {
  return new TtDateRangePipe().transform(range, {
    divider: divider,
    format: formatString,
  });
}

export function intRangeHumanReadableString(
  range: Parameters<TtNumberRangePipe['transform']>[0],
  divider: string = ' - ',
  formatString: string = '1.0-3',
) {
  return new TtNumberRangePipe().transform(range, {
    locale: 'nl-NL',
    divider: divider,
    format: formatString,
  });
}
